<script lang="ts">
	interface Props {
		quote: string;
		name: string;
		subtitle?: string; // Course name or role
		variant?: 'quote' | 'stars';
		rating?: number; // For star variant (1-5)
		showAvatar?: boolean; // For star variant - show initials circle
	}

	let {
		quote,
		name,
		subtitle = '',
		variant = 'quote',
		rating = 5,
		showAvatar = true
	}: Props = $props();
</script>

<div class="bg-linear-card rounded-lg border border-ak-border-subtle p-4 sm:p-5">
	{#if variant === 'quote'}
		<!-- Quote Icon -->
		<div class="w-10 h-10 rounded-full bg-ak-wintergreen-dim flex items-center justify-center mb-4">
			<svg class="w-5 h-5 text-ak-wintergreen" fill="currentColor" viewBox="0 0 24 24">
				<path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
			</svg>
		</div>
	{:else}
		<!-- Star Ratings -->
		<div class="flex items-center gap-1 mb-3">
			{#each Array(rating) as _}
				<svg class="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 24 24">
					<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
				</svg>
			{/each}
		</div>
	{/if}

	<!-- Quote Text -->
	<p class="text-ak-text-secondary mb-4 leading-relaxed">
		"{quote}"
	</p>

	<!-- Author -->
	<div class="flex items-center gap-3">
		{#if variant === 'stars' && showAvatar}
			<div class="w-10 h-10 rounded-full bg-ak-wintergreen-dim flex items-center justify-center">
				<span class="text-ak-wintergreen font-bold text-sm">
					{name.split(' ').map(n => n.charAt(0)).join('')}
				</span>
			</div>
		{:else}
			<div class="w-12 h-12 rounded-full bg-ak-wintergreen-dim flex items-center justify-center">
				<span class="text-ak-wintergreen font-semibold text-lg">
					{name.charAt(0)}
				</span>
			</div>
		{/if}

		<div>
			<div class="font-semibold text-sm text-ak-text-primary">{name}</div>
			{#if subtitle}
				<div class="text-sm text-ak-text-secondary">{subtitle}</div>
			{/if}
		</div>
	</div>
</div>
